export default {
  bold: 'Tučné',
  italic: 'Kurzíva',
  underline: 'Podčiarknutie',
  list: 'Zoznam',
  link: 'Odkaz',
  codeblock: 'Blok kódu',
};
